<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 771.000000 833.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,833.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M3891 8320 c-470 -39 -725 -153 -854 -383 -26 -47 -54 -91 -62 -97
-11 -9 -41 3 -147 62 l-133 73 -85 -1 c-107 0 -386 -63 -442 -100 -121 -78
-251 -282 -315 -494 -33 -108 -37 -287 -9 -390 42 -157 157 -339 275 -437 172
-143 341 -193 701 -208 222 -10 259 -38 181 -138 -55 -73 -87 -148 -101 -239
-13 -87 -2 -170 28 -222 23 -41 94 -76 152 -76 121 1 292 71 418 174 108 88
133 100 202 93 106 -9 199 -82 227 -176 29 -100 -9 -277 -148 -693 -49 -146
-89 -282 -89 -301 0 -56 21 -65 89 -40 31 12 93 35 138 52 219 81 454 57 705
-71 198 -101 377 -271 429 -407 38 -101 18 -238 -38 -264 -35 -16 -73 7 -179
105 -50 47 -115 103 -145 126 -253 191 -700 218 -843 51 -25 -30 -37 -56 -45
-101 -13 -78 -31 -104 -80 -119 -35 -10 -57 -8 -181 21 -124 29 -153 32 -245
28 -103 -5 -106 -6 -221 -62 -136 -66 -209 -81 -319 -65 -96 13 -151 32 -287
100 -65 33 -127 59 -138 59 -32 0 -25 -39 20 -111 89 -141 101 -203 47 -243
-37 -27 -150 -33 -347 -16 -156 13 -200 7 -200 -28 0 -24 65 -84 173 -162 108
-77 147 -113 147 -134 0 -21 -12 -20 -155 5 -135 25 -193 21 -247 -14 -81 -54
-92 -164 -44 -447 39 -233 31 -310 -40 -357 -43 -27 -133 -20 -254 21 -157 54
-180 46 -84 -27 201 -151 241 -192 270 -277 40 -115 -58 -226 -318 -365 -150
-79 -159 -98 -31 -70 160 36 483 160 706 271 236 118 578 319 892 524 264 173
370 226 624 314 312 109 621 149 621 82 0 -8 -37 -43 -82 -77 -264 -199 -460
-513 -461 -739 0 -163 44 -207 407 -396 200 -104 214 -116 202 -177 -9 -49
-56 -99 -280 -295 -244 -213 -435 -403 -460 -456 -37 -78 -4 -87 183 -56 101
17 133 20 150 10 59 -31 -39 -136 -358 -383 -83 -64 -219 -170 -303 -234 -236
-183 -353 -301 -332 -335 15 -24 127 2 390 92 887 304 1288 409 2099 550 325
57 328 57 319 72 -8 13 -151 7 -639 -28 -366 -26 -836 -42 -898 -30 -42 8 -49
29 -16 47 45 23 201 72 424 130 127 33 316 83 420 110 392 103 599 175 646
225 l24 26 -26 22 c-46 40 -197 60 -564 76 -499 21 -518 27 -264 84 291 65
791 120 1364 151 382 20 488 40 608 117 73 46 159 148 206 241 57 113 74 190
69 302 -6 113 -30 168 -109 246 -69 69 -146 108 -327 169 -74 25 -134 50 -133
55 1 6 23 9 49 8 26 -1 133 -3 237 -4 213 -3 283 10 406 72 239 120 376 337
505 797 99 356 121 509 90 632 -28 112 -64 227 -88 288 -114 279 -363 468
-674 511 -43 6 -79 13 -80 14 -2 2 19 54 46 117 138 323 185 629 145 951 -21
171 -52 286 -105 389 -132 252 -368 401 -716 450 -117 16 -374 23 -494 12 -58
-5 -106 -8 -107 -7 -1 0 5 21 14 45 22 61 11 111 -34 161 -72 80 -266 149
-417 149 -168 0 -271 -50 -476 -230 -172 -150 -229 -182 -293 -161 -141 47
-185 335 -71 461 77 85 155 112 409 145 214 28 248 36 296 68 49 33 61 61 56
137 -5 83 -46 173 -126 272 -128 161 -320 285 -546 354 -79 24 -109 27 -245
30 -85 1 -202 -2 -259 -6z"
      />
      <path
        d="M1793 6623 c-14 -32 -59 -150 -100 -263 -42 -113 -107 -272 -146
-355 -38 -82 -93 -202 -122 -266 -54 -120 -272 -489 -474 -804 -83 -128 -140
-205 -201 -268 -110 -116 -227 -213 -320 -267 -219 -128 -332 -254 -395 -443
-37 -111 -42 -193 -16 -235 49 -78 125 -90 261 -42 46 17 102 30 123 30 l40 0
-7 -92 c-10 -129 -23 -184 -62 -254 -33 -59 -34 -64 -34 -175 -1 -79 -6 -126
-16 -154 -56 -142 -2 -240 155 -280 66 -16 84 -46 89 -148 5 -100 -15 -184
-57 -237 -65 -82 -121 -234 -121 -328 0 -30 5 -84 11 -119 13 -74 41 -113 102
-145 35 -17 52 -20 121 -14 264 20 286 19 426 -8 154 -29 413 -60 640 -76 172
-12 206 -20 267 -61 121 -84 177 -231 177 -474 1 -112 -1 -125 -32 -201 -45
-113 -99 -192 -210 -309 -167 -175 -178 -213 -57 -180 100 27 217 87 264 136
68 71 138 188 183 304 36 95 42 123 46 206 7 159 -8 237 -77 388 -32 72 -71
151 -86 176 -30 52 -122 125 -187 149 -52 19 -300 52 -498 66 -80 6 -206 21
-280 33 -110 18 -162 21 -280 17 -80 -2 -194 -4 -255 -5 l-110 0 -3 50 c-6 89
15 163 73 255 76 122 93 160 105 231 15 93 12 218 -6 278 -26 90 -111 161
-212 177 l-39 6 13 57 c8 31 14 102 14 159 l0 102 53 0 c30 0 80 -9 112 -20
83 -29 287 -70 345 -70 64 0 74 19 35 60 -53 55 -373 200 -442 200 -24 0 -33
4 -33 17 0 16 31 205 35 211 1 1 33 -9 71 -24 51 -19 79 -24 107 -20 43 7 128
47 143 68 6 7 21 64 34 126 28 139 24 244 -10 312 -20 39 -24 42 -35 27 -6 -9
-17 -49 -24 -88 -19 -119 -79 -241 -132 -269 -16 -9 -30 -4 -77 24 -77 48
-160 76 -225 76 -47 0 -145 -14 -254 -36 l-32 -6 39 91 c67 158 135 232 303
332 180 106 249 164 405 341 111 126 160 190 214 283 39 66 154 260 256 431
l186 311 50 -5 c28 -2 94 -15 146 -29 52 -13 147 -38 210 -54 121 -31 232 -41
251 -22 35 35 -77 100 -363 214 -115 45 -208 86 -208 90 0 5 29 82 65 171 89
224 116 338 122 510 8 200 -7 235 -54 131z"
      />
      <path
        d="M1507 5253 c-13 -13 -6 -35 47 -156 29 -67 68 -167 85 -222 18 -55
39 -110 47 -122 24 -37 66 -29 214 41 74 35 174 82 223 104 48 23 87 46 87 52
0 11 -10 16 -108 51 -38 13 -98 48 -150 87 -102 76 -196 122 -309 151 -84 22
-125 26 -136 14z"
      />
    </g>
  </svg>
</template>
